import {
  FormHelperText,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from '@mui/material';
import {
  FormsErrorDataType,
  HubSpotForms,
} from 'containers/dashboard/Forms/FormListingType';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onChangeElement: (
    e:
      | React.ChangeEvent<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
      | SelectChangeEvent
  ) => void;
  hubspotForms: HubSpotForms[];
  selectedHubspotFormId: string;
  name: string;
  stateError: FormsErrorDataType;
};
const FormSettingsForm: FunctionComponent<Props> = ({
  name,
  hubspotForms,
  selectedHubspotFormId,
  onChangeElement,
  stateError,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction='column' spacing='30px'>
      <TextField
        onChange={onChangeElement}
        id='outlined-basic'
        name='name'
        label={t('form_name')}
        variant='outlined'
        value={name}
        error={stateError.name.length ? true : false}
        helperText={<span>{stateError.name}</span>}
      />
      <FormControl fullWidth>
        <InputLabel id='demo-simple-select-label'>
          {t('select_hubspot_form')}
        </InputLabel>
        <Select
          id='demo-simple-select-helper'
          value={selectedHubspotFormId}
          label={t('select_hubspot_form')}
          variant='outlined'
          name='selectedHubspotFormId'
          onChange={onChangeElement}
          error={stateError.selectedHubspotFormId.length ? true : false}
        >
          <MenuItem key='selecthub' value='select'>
            {t('select_hubspot_form')}
          </MenuItem>
          {hubspotForms.map((row, index) => {
            return (
              <MenuItem key={row.guid} value={row.guid}>
                {row.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      {stateError.selectedHubspotFormId.length > 0 && (
        <FormHelperText error={true}>
          <span>{stateError.selectedHubspotFormId}</span>
        </FormHelperText>
      )}
    </Stack>
  );
};

export default React.memo(FormSettingsForm);
